export const financialMoreInfoDialog = {
  nl: `Als aanbieder is uw makelaar verplicht om de solvabiliteit van de kandidaat-huurders na te gaan. Zodat je financieel comfortabel zou kunnen huren hanteren wij volgende basisregel:
  
**gezamenlijk netto-inkomen huurders\\* > of = 3x totale huurprijs \\*\\***

\\*inkomsten die je (individueel of met je samenwonende partner) maandelijks werkelijk uitbetaald krijgt of overhoudt,
na aftrek van oa. belastingen en sociale bijdragen.

\\*\\*(basishuur \\+ ev. huur garage \\+ ev. gemeenschappelijke kosten).

**Voorbeeld:**
- appartement: 500 EUR / maand
- garagebox: 50 EUR / maand
- gemeenschappelijke kosten: 50 EUR / maand

_=> de huurders moeten samen minstens over 1.800 EUR (3x (500 \\+ 50 \\+ 50)) netto-inkomen beschikken._`,
  en: `In order to rent comfortably we apply the following basic rule:

**joint net income tenants* > or = 3 x total rent ****

\\* income that you (individually or with your cohabiting partner) actually receive or retain eacg month, after deduction of taxes and social security contributions.

\\*\\*(basic rent + garage rent, if applicable + common costs, if applicable)

**Example:**

- apartment: 500 EUR / month
- garage: 50 EUR / month
- common costs: 50 EUR / month

_=> the tenants must have a net income of at least 1.800 EURO (3x (500 + 50 + 50))_`,
  fr: `Voici le calcul que nous appliquons pour déterminer le loyer que vous serez en mesure de prendre en charge:

**Revenu net cumulé des locataires* > ou = à 3x le loyer total ****

\\* revenus mensuels nets ou réels (pour vous seul(e) ou avec votre partenaire cohabitant), après déduction notamment des impôts et cotisations sociales.

\\*\\*(loyer de base + éventuelle location d’un garage + éventuelles charges communes)

**Exemple:**

- appartement: 500 EURO / mois
- garage: 50 EUR / mois
- coûts communs: 50 EUR / mois

_=> les locataires doivent avoir un revenu net d'au moins 1.800 EUR (3x (500 + 50 + 50))_`,
}

export const privacyConditionsText = {
  nl: `
## PRIVACY VOORWAARDEN – RENTIO HUURPROFIEL

Via uw Rentio huurprofiel kunt u uw persoonlijke gegevens en documenten op een veilige en efficiënte wijze versturen naar een makelaar. Het Rentio huurprofiel is een product van Rentio NV.

Rentio en haar geregistreerde makelaars gaan zorgvuldig om met privacy gevoelige informatie. In deze privacyverklaring leest u welke gegevens worden geregistreerd in uw Rentio huurprofiel en op welke wijze uw gegevens worden verwerkt.

Bij de verwerking van uw gegevens leeft Rentio evident de wet na, momenteel de Belgische wet van 8 december 1992 en de Europese verordening nr. 2016/679 van 27 april 2016 betreffende de gegevensbescherming (beter bekend als ‘GDPR’ of ‘AVG’) of enig ander wetgevingsbesluit die deze wijzigt.

Meer informatie over gegevensbescherming kunt u verkrijgen bij de Belgische Commissie voor de bescherming van de persoonlijke levenssfeer, vanaf 25 mei 2018 de Gegevensbeschermingsautoriteit genoemd.

U kunt contact opnemen met onze functionaris voor gegevensbescherming (‘DPO’) door hem aan te schrijven op het volgend adres : dhr Stijn Roels, Hoogstraat 60, 2820 Rijmenam, of door een e-mail te sturen naar : [privacy@rentio.be](mailto:privacy@rentio.be).

Makelaars gebruiken uw gegevens voor de realisatie van een bemiddeling als u een woning wenst te (ver)huren.

### Persoonsgegevens die wij verwerken  
Rentio verwerkt persoonsgegevens over u doordat u gebruik maakt van het Rentio huurprofiel en u deze zelf aan ons verstrekt. Hieronder een overzicht:

-   Voor- en achternaam
-   Mobiel telefoon-nummer
-   Adresgegevens
-   E-mailadres
-   Burgerlijke staat
-   Overige persoonsgegevens en documenten die u actief verstrekt bijvoorbeeld door een profiel op deze website aan te maken, documenten te uploaden en in berichten naar de makelaar
-   Identiteitsgegevens
-   Locatiegegevens
-   De huurintentie en woonwensen
-   De reden van (ver)huur
-   Inkomensgegevens
-   Gezinssamenstelling
-   Huidige huurgegevens (duurtijd, adres, eigenaar)
-   Gegevens over uw activiteiten op onze website
-   Internetbrowser en apparaat type

### Bijzondere en/of gevoelige persoonsgegevens die wij verwerken  
Rentio en haar geregistreerde makelaars verwerken uw gegevens voor de uitvoering van de verificatie van identiteit, solvabiliteit en kredietwaardigheid.

Om in aanmerking te komen voor een huurwoning doet de makelaar deze checks. Het is de zorgplicht van de makelaar om huurders en verhuurders te beschermen tegen misbruik, waardoor deze checks worden uitgevoerd zodra een bemiddeling tot stand komt.

Rentio kan tevens uw persoonlijke elektronische contactgegevens (namelijk uw mobiele telefoonnummer en e-mailadres) verwerken om u persoonlijke informatie, advertenties of voorstellen toe te sturen via directe marketing of nieuwsbrieven. In dit geval vraagt Rentio eerst uw specifieke toestemming. Door deze privacy policy te aanvaarden, geeft u uw toestemming voor het verwerken van uw persoonsgegevens voor elektronische direct marketing doeleinden én het versturen van elektronische reclame.

### Waarom we gegevens nodig hebben  
Rentio en haar geregistreerde makelaars verwerken uw persoonsgegevens, voor de volgende doelen:

-   Het gericht aanbieden van huurwoningen
-   Realiseren van een bemiddeling
-   Opmaak van de huurovereenkomst
-   Met u communiceren
-   Directe marketing of nieuwsbrieven.

### Beveiliging en bewaartermijn

Rentio en haar geregistreerde makelaars zullen er voor zorgen dat uw gegevens veilig worden opgeslagen en dat deze adequaat worden beschermd tegen ongeautoriseerd gebruik, ongeautoriseerde toegang, wijziging of onrechtmatige vernietiging. Uw gegevens worden bewaard zolang als noodzakelijk voor de hiervoor genoemde doeleinden of zover dit noodzakelijk is vanwege wettelijke verplichtingen of voor het oplossen van eventuele geschillen.

Rentio bewaart uw persoonsgegevens binnen de EER. Er worden dan ook geen gegevens overgebracht naar landen buiten de EER.

### Delen met anderen

U heeft zelf de regie over uw persoonlijke profiel in bij Rentio. U bepaalt welke gegevens met wie worden gedeeld. Met de makelaars die uw gegevens verwerken en zijn aangesloten op Rentio, sluit Rentio een bewerkersovereenkomst om te zorgen voor eenzelfde niveau van beveiliging en vertrouwelijkheid van uw gegevens. Uw gegevens mogen alleen gedeeld worden met belanghebbenden voor de uitvoering van een succesvolle bemiddeling zoals bijvoorbeeld de partijen die in een huurovereenkomst worden opgenomen zijnde de huurder, verhuurder en beheerder. Rentio gebruikt geen cookies.

### Beveiliging

Rentio hanteert strikte normen om de persoonsgegevens onder haar controle te beschermen tegen ongeoorloofde of onrechtmatige verwerking en tegen onopzettelijk verlies, vernietiging op beschadiging.

Rentio neemt dan ook maatregelen van technische en organisatorische aard zoals encryptie, antivirus, firewalls, toegangscontroles, strenge selectie van medewerkers en leveranciers, om ongepaste toegang, verlies of openbaarmaking van uw persoonsgegevens te voorkomen en te detecteren.

In het onwaarschijnlijke en ongelukkige geval dat uw persoonsgegevens onder de controle van Rentio gecompromitteerd worden door een inbreuk op de informatiebeveiliging, zal Rentio onmiddellijk handelen om de oorzaak van dergelijke inbreuk te identificeren en actie ondernemen via adequate remediërende maatregelen. Indien nodig, zal Rentio u, evenals de Gegevensbeschermingsautoriteit, in kennis stellen van dit incident in overeenstemming met de toepasselijke wetgeving.

Als u de indruk heeft dat uw gegevens niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan direct contact op met onze DPO (zie boven).

### Vragen?
Uw vragen over de software en privacyverklaring stelt u aan Rentio.`,
  en: `## PRIVACY STATEMENT – RENTIO RENTAL PROFILE

Through your Rentio rental profile you can send your personal data and documents to a real estate broker in a safe and efficient way. The Rentio rental profile is a product of Rentio NV.

Rentio and its registered real estate agents handle privacy sensitive information with care. In this privacy statement you can read which data are registered in your Rentio rental profile and how your data are processed.

When processing your data, Rentio clearly complies with the law, currently the Belgian law of 8 December 1992 and the European regulation no. 2016/679 of 27 April 2016 concerning data protection (better known as 'GDPR' or 'AVG') or any other legal act amending it.

More information about data protection can be obtained from the Belgian Commission for the protection of privacy, known as the Data Protection Authority from 25 May 2018.

You can contact our DPO by writing at the following address: Mr Stijn Roels, Hoogstraat 60, 2820 Rijmenam, or by sending an e-mail to: [privacy@rentio.be](mailto:privacy@rentio.be).

Brokers use your data for the realization of a mediation if you wish to rent or rent a property.

### Personal data that we process  
Rentio processes personal data about you by using the Rentio rental profile and you provide it yourself. Below an overview:

-   First name and name
-   Mobile phone number
-   Address details
-   E-mail address
-   Marital status
-   Other personal data and documents that you actively provide by, for example, creating a profile on this website, uploading documents and sending messages to the broker
-   Identity data
-   Location data
-   The rental intention and housing requirements
-   The reason for rent(al)
-   Income data
-   Family composition
-   Current rental data (duration, address, owner)
-   Information about your activities on our website
-   Internet browser and device type

### Special and / or sensitive personal data that we process  
Rentio and its registered brokers process your data for the execution of the verification of identity, solvency and creditworthiness.

In order to qualify for a rental property, the broker carries out these checks. It is the duty of care of the broker to protect tenants and landlords against abuse, as a result of which these checks are carried out as soon as a mediation is established.

Rentio can also process your personal electronic contact information (ie your mobile phone number and e-mail address) to send you personal information, advertisements or proposals via direct marketing or newsletters. In this case Rentio first asks for your specific permission. By accepting this privacy policy, you consent to the processing of your personal data for electronic direct marketing purposes and the sending of electronic advertising.

### Why we need data  
Rentio and its registered brokers process your personal data for the following purposes:

-   The targeted provision of rental housing
-   Realizing a mediation
-   Drafting the lease
-   Communicate with you
-   Direct marketing or newsletters.

 

### Security and storage period

Rentio and its registered agents will ensure that your data is stored securely and that it is adequately protected against unauthorized use, unauthorized access, modification or unlawful destruction. Your data will be kept for as long as necessary for the aforementioned purposes or as far as this is necessary due to legal obligations or for resolving any disputes.

Rentio stores your personal data within the EEA. No data is therefore transferred to countries outside the EEA.

### Share with others

You yourself have control over your personal profile with Rentio. You determine which information is shared with whom. With the brokers who process your data and are connected to Rentio, Rentio enters into a processor agreement to ensure the same level of security and confidentiality of your data. Your data may only be shared with stakeholders for the execution of a successful mediation, such as the parties that are included in a rental agreement, ie the tenant, landlord and manager. Rentio does not use cookies.

### Security

Rentio uses strict standards to protect the personal data under its control against unauthorized or unlawful processing and against unintentional loss, destruction on damage.

Rentio therefore also takes technical and organizational measures such as encryption, antivirus, firewalls, access controls, strict selection of employees and suppliers, to prevent and detect inappropriate access, loss or disclosure of your personal data.

In the unlikely and unfortunate case that your personal data under the control of Rentio are compromised by a breach of information security, Rentio will immediately act to identify the cause of such breach and take action through appropriate remedial measures. If necessary, Rentio will inform you, as well as the Data Protection Authority, of this incident in accordance with the applicable legislation.

If you have the impression that your data is not secure or that there are indications of abuse, please contact our DPO directly (see above).

### Questions?

You ask Rentio about your questions about the software and privacy statement.`,
  fr: `## POLITIQUE DE LA VIE PRIVEE – RENTIO PROFIL DE LOCATION**

Grâce à votre profil de location Rentio, vous pouvez envoyer vos données personnelles et vos documents à une agence de manière sûre et efficace. Le profil de location Rentio est un produit de Rentio NV.

Rentio et ses agents immobiliers enregistrés gèrent les informations confidentielles avec soin. Dans cette déclaration de confidentialité, vous pouvez lire quelles données sont enregistrées dans votre profil de location Rentio et comment elles sont traitées.

Lors du traitement de vos données, Rentio respecte clairement la loi, actuellement la loi Belge du 8 décembre 1992 et le règlement européen n ° 2016/679 du 27 avril 2016 concernant la protection des données (mieux connu sous le nom de ‘RGPD’ ou ‘GDPR’ en anglais) ou tout autre législation l'amendant.

Plus d'informations sur la protection des données peuvent être obtenues auprès de la Commission Belge pour la protection de la vie privée, du 25 mai 2018 a appelé l'Autorité de protection des données.

Vous pouvez contacter notre DPO en écrivant à l'adresse suivante: Mr. Stijn Roels, Hoogstraat 60, 2820 Rijmenam, ou en envoyant un email à l'adresse: [privacy@rentio.be](mailto:privacy@rentio.be).

Les agences immobilières utilisent vos données pour la réalisation d'une médiation si vous souhaitez louer une propriété.

### Données personnelles que nous traitons  
Rentio traite des données personnelles vous concernant en utilisant le profil de location Rentio et vous les fournissez vous-même. Ci-dessous un aperçu:

-   Nom et prénom
-   Numéro de gsm
-   Adresse
-   Adresse email
-   Etat civil
-   Autres données personnelles et documents que vous fournissez activement, par exemple en créant un profil sur ce site web, en téléchargeant des documents et des messages vers l’agence
-   Données d’identité
-   Données de localisation
-   L'intention de location et les conditions de logement
-   La raison de la location
-   Données de revenu
-   Composition de la famille
-   Données de location actuelles (durée, adresse, propriétaire)
-   Informations sur vos activités sur notre site web
-   Navigateur internet et type d’appareil

### Données personnelles spéciales et / ou sensibles que nous traitons  
Rentio et ses agents immobiliers enregistrés traitent vos données pour l'exécution de la vérification de l'identité et de la solvabilité.  Afin de se qualifier pour un bien locatif, l’agence effectue ces contrôles. Il incombe à l'agent immobilier de protéger les locataires et les propriétaires contre les utilisations abusives. Ces contrôles sont donc effectués dès que la médiation est établie.

Rentio peut également traiter vos informations de contact électroniques personnelles (Votre numéro de téléphone mobile et votre adresse e-mail) pour vous envoyer des informations personnelles, des publicités ou des propositions via le marketing direct ou des lettres d'information. Dans ce cas, Rentio demande d’abord votre autorisation spécifique.

En acceptant cette politique de la vie privée, vous consentez au traitement de vos données personnelles à des fins de marketing direct électronique et à l'envoi de publicités électroniques.

### Pourquoi avons-nous besoin de données  
Rentio et ses agences enregistrées traitent vos données personnelles aux fins suivantes:

-   Une offre ciblée de biens locatifs
-   Réaliser une médiation
-   Mise en page du bail
-   communiquer avec vous
-   Marketing direct ou lettres d’information.

### Sécurité et période de stockage

Rentio et ses agences enregistrées veilleront à ce que vos données soient stockées de manière sécurisée et à ce qu'elles soient protégées de manière adéquate contre toute utilisation non autorisée, accès non autorisé, modification ou destruction illégale. Vos données seront conservées aussi longtemps que nécessaire aux fins susmentionnées ou dans la mesure où cela est nécessaire en raison d'obligations légales ou pour la résolution de tout litige.  Rentio stocke vos données personnelles dans l'EEE. Aucune donnée n'est donc transférée à des pays hors de l'EEE.

### Partager avec d'autres

Vous avez vous-même le contrôle de votre profil personnel chez Rentio. Vous déterminez quelle information est partagée avec qui. Avec les agences qui traitent vos données et sont connectés à Rentio, Rentio conclut un contrat de traitement pour assurer le même niveau de sécurité et de confidentialité de vos données.  Vos données ne peuvent être partagées avec les parties prenantes que pour l'exécution d'une médiation réussie, telles que les parties incluses dans un contrat de location, à savoir le locataire, le propriétaire et le gestionnaire. Rentio n'utilise pas de cookies.

### La sécurité

Rentio applique des normes strictes pour protéger les données personnelles sous son contrôle contre les traitements non autorisés ou illicites et contre la perte, la destruction ou les dommages non intentionnels.

Rentio prend donc également des mesures techniques et organisationnelles telles que cryptage, antivirus, pare-feu, contrôles d'accès, sélection stricte d'employés et de fournisseurs, pour prévenir et détecter les accès inappropriés, la perte ou la divulgation de vos données personnelles.

Dans le cas peu probable et malheureux que vos données à caractère personnel sous le contrôle de Rentio soient compromises par une violation de la sécurité des informations, Rentio agira immédiatement pour identifier la cause de cette violation et prendra les mesures appropriées en conséquence.

Si nécessaire, Rentio vous informera, ainsi que l'autorité de protection des données, de cet incident conformément à la législation en vigueur.

Si vous avez l'impression que vos données ne sont pas sécurisées ou qu'il existe des indices d'abus, veuillez contacter directement notre DPD (voir ci-dessus).

### Questions?

Vous posez des questions à Rentio sur le logiciel et la déclaration de confidentialité.`,
}



// WEBPACK FOOTER //
// ./src/services/translationTexts.js